export class Installments {

    Id : number;
    LoanId : number;
    WeekOfYear : string;
    DayOfWeek : string;
    Date : Date;
    InstallmentAmount : number;
    EmployeeId  : number;
    EmployeeBranchId  : number;
    CompanyId  : number;
    SaasId  : number;
    IsActive : boolean;
    Flag: Number;
}
